import AWS from 'aws-sdk'
export const awsRegion = 'us-west-2'
export const cognitoRegion = 'us-west-2'
export const cognitoUserPoolId = 'us-west-2_5zAV9KuoX'
export const cognitoIdentityPoolId = 'us-west-2:1afe20d1-be0e-47b9-a3e9-4b74d92256bf'
export const cognitoClientId = '7shbfk35dsqpd00ja39qlhhip5'

AWS.config.region = cognitoRegion



/** WEBPACK FOOTER **
 ** ./src/services/aws.js
 **/